var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTurnoverIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 76,
    fill: "none",
    viewBox: "0 0 69 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#230CC2",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M11.74 21.41l11.981 36.448a3.143 3.143 0 0 0 4.06 1.972l38.544-14.018c1.32-.48 2-1.939 1.52-3.258-.48-1.32-1.94-2-3.26-1.52L28.938 53.998a1.257 1.257 0 0 1-1.625-.791L11.052 3.314A3.352 3.352 0 0 0 6.138 1.48L2.444 3.699a2.975 2.975 0 0 0-1.263 3.569 2.135 2.135 0 0 0 3.007 1.155l1.49-.792a1.048 1.048 0 0 1 1.488.6l1.308 4.015"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#230CC2",
    d: "M10.73 18.466a1.538 1.538 0 1 0-1.053-2.892 1.538 1.538 0 1 0 1.053 2.892z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#230CC2",
    strokeWidth: 2,
    d: "M33.445 52.348l-8.397-23.052a.837.837 0 0 1 .5-1.073l24.792-9.016a.838.838 0 0 1 1.073.5L59.81 42.76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#230CC2",
    strokeWidth: 2,
    d: "M46.36 20.657L41.014 5.982a.838.838 0 0 0-1.074-.5L23.995 11.28a.837.837 0 0 0-.5 1.074l5.345 14.675"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#230CC2",
    strokeWidth: 2,
    d: "M29.346 9.335l1.875 5.148a.419.419 0 0 0 .744.085l1.272-1.951a.419.419 0 0 1 .481-.17l2.105.689a.419.419 0 0 0 .523-.541L34.48 7.468M34.53 24.958l3.25 8.919a.419.419 0 0 0 .742.087l1.871-2.836a.419.419 0 0 1 .449-.177l3.691.895a.419.419 0 0 0 .492-.55L41.76 22.33M34.925 74.365a8.057 8.057 0 0 0 4.818-10.33 8.067 8.067 0 0 0-10.337-4.82 8.057 8.057 0 0 0-4.818 10.331 8.067 8.067 0 0 0 10.337 4.82z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#230CC2",
    strokeWidth: 2,
    d: "M33.527 70.529a3.976 3.976 0 0 0 2.378-5.099 3.981 3.981 0 0 0-5.101-2.378 3.976 3.976 0 0 0-2.378 5.098 3.981 3.981 0 0 0 5.101 2.379z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnoverIconSelected);
export default __webpack_public_path__ + "static/media/turnover-icon-selected.18845d18bc374aa2ad083c4759d01c5c.svg";
export { ForwardRef as ReactComponent };